import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { DemandRequestDetailService } from '../demand-request-detail.service';

@Component({
  template: '',
  standalone: false,
})
export abstract class RequestTypeBaseComponent {
  public get model$() {
    return this.demandRequestDetailService.model$;
  }

  public get requestTypeId$() {
    return this.demandRequestDetailService.requestTypeId$;
  }

  public get currency$() {
    return this.demandRequestDetailService.currency$;
  }

  public get form(): FormGroup {
    return this.demandRequestDetailService.requestTypeForm;
  }

  public set form(value: FormGroup) {
    this.demandRequestDetailService.requestTypeForm = value;
  }

  public get options(): FormlyFormOptions {
    return this.demandRequestDetailService.options;
  }

  public set options(value: FormlyFormOptions) {
    this.demandRequestDetailService.options = value;
  }

  public get formFieldAppearance(): string {
    return this.demandRequestDetailService.formFieldAppearance;
  }

  public get isReadOnly$() {
    return this.demandRequestDetailService.isReadOnly$;
  }

  public fields: FormlyFieldConfig[] = [];

  constructor(
    protected demandRequestDetailService: DemandRequestDetailService
  ) {}
}
